import {
  CHANGE_PASSWORD,
  EDIT_USER_INFO,
  FETCH_DISCOUNT_LIST,
  FETCH_REGION,
  FETCH_REVIEWS_ABOUT_USER,
  FETCH_USER_INFO,
  FETCH_USER_REVIEWS,
  UPDATE_BANK_ACCOUNT,
  UPLOAD_PHOTO,
} from '../actions/types'

export interface BankAccountType {
  owner_name: string
  owner_family: string
  sheba: string
  account_number: string
  card_number: string
}
export interface UserInfoDataType {
  name: string
  family: string
  mobile: string
  profile_photo: string
  email: string
  credit: number | null
  company_balance: number | null
  cashable_balance: number | null
  prize_balance: number
  non_cashable_balance: number
  national_number: string | null
  about_me: string
  living_city: string
  living_province: string
  gender: 'male' | 'female' | 'other' | null
  tel: string | null
  birthdate: string | null
  address: string | null
  is_host: boolean
  created_at: string | null
}
export interface UserInfo {
  data: UserInfoDataType | null
  loading: boolean
}
export const userInfo = (
  state: UserInfo = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case FETCH_USER_INFO:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface EditUserInfo {
  email: string
  gender: string
  phone_number: number
  birth_date: Date
  about_me: string
  living_city: string
  living_province: string
  address: string
}
export interface EditUserInfoType {
  data: EditUserInfo | null
  loading: boolean
}
export const editUserInfo = (
  state: EditUserInfoType = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case EDIT_USER_INFO:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

type Coordinate = {
  lat: number
  lng: number
}

export type CityType = {
  region_id: string
  name: string
  count_of_houses: number
  coordinate: Coordinate
}

export type RegionItemType = {
  region_id: string
  name: string
  count_of_houses: number
  coordinate: Coordinate
  cities: CityType[]
}

export interface Region {
  data: RegionItemType[]
  loading: boolean
}
export const region = (
  state: Region = { data: [], loading: false },
  action,
) => {
  switch (action.type) {
    case FETCH_REGION:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface DiscountData {
  price: string
  code: string
  end_date: string
}
export interface DiscountList {
  data: DiscountData[] | null
  loading: boolean
}
export const discountList = (
  state: DiscountList = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case FETCH_DISCOUNT_LIST:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface PasswordInfo {
  old_password: string
  new_password: string
  new_password_confirmation: string
  message: string
}
export interface ChangePassword {
  data: PasswordInfo | null
  loading: boolean
}
export const changePassword = (
  state: ChangePassword = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case CHANGE_PASSWORD:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface BankAccount {
  owner_name: string
  owner_family: string
  sheba: string
  account_number: string
  card_number: string
}
export interface UpdateBankAccount {
  data: BankAccount | null
  loading: boolean
}

export const updateBankAccount = (
  state: UpdateBankAccount = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case UPDATE_BANK_ACCOUNT:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}
export interface TargetUser {
  name: string
  family: string
  profile_photo: string
}
export interface House {
  title: string
}
export interface Reviews {
  target_user: TargetUser
  house: House
  description: string
  positives: string[]
  negatives: string[]
  created_at: string
}
export interface Reviewless {
  target_user: TargetUser
  house: House
  remaining_days_for_review: number | null
  link: string
}
export interface UserReviewsDataType {
  reviews: Reviews[]
  reviewless: Reviewless[]
}
export interface UserReviews {
  data: UserReviewsDataType | null
  loading: boolean
}
export const userReviews = (
  state: UserReviews = {
    data: null,
    loading: false,
  },
  action,
) => {
  switch (action.type) {
    case FETCH_USER_REVIEWS:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface UserReviewsType {
  created_at: string
  description: string
  house: House
  user: TargetUser
}
export interface ReviewsAboutUser {
  data: UserReviewsType[] | null
  loading: boolean
}
export const reviewsAboutUser = (
  state: ReviewsAboutUser = {
    data: null,
    loading: false,
  },
  action,
) => {
  switch (action.type) {
    case FETCH_REVIEWS_ABOUT_USER:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface pictureType {
  picture: any
}
export interface UploadPhoto {
  data: pictureType | null
  loading: boolean
}
export const uploadPhoto = (
  state: UploadPhoto = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case UPLOAD_PHOTO:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}
